import type { RdVerdict, RdVerifyResult } from '@dcc-erp/shared';

export interface RdVerifyChipProps {
  /** The verdict snapshot from IngestProposal.rdVerify; null = DISABLED / none. */
  result: RdVerifyResult | null;
  /** Re-run RD verify (UNKNOWN/pending). */
  onRecheck?: () => void;
  recheckBusy?: boolean;
}

const CHIP: Record<RdVerdict, { cls: string; icon: string; label: string }> = {
  VERIFIED: { cls: 'badge positive', icon: '🟢', label: 'ตรงกับกรมสรรพากร' },
  NAME_MISMATCH: { cls: 'badge warning', icon: '🟡', label: 'ชื่อไม่ตรงทะเบียน' },
  BRANCH_MISMATCH: { cls: 'badge warning', icon: '🟡', label: 'สาขาไม่ตรงทะเบียน' },
  NOT_VAT_REGISTERED: { cls: 'badge negative', icon: '🔴', label: 'ผู้ขายไม่ได้จดทะเบียน VAT' },
  INVALID_TAX_ID: { cls: 'badge negative', icon: '🔴', label: 'เลขภาษีไม่ถูกต้อง' },
  UNKNOWN: { cls: 'badge neutral', icon: '⚪', label: 'ตรวจสอบไม่ได้ (กำลังตรวจซ้ำ)' },
  DISABLED: { cls: 'badge neutral', icon: '⚪', label: '' },
};

export function RdVerifyChip({ result, onRecheck, recheckBusy }: RdVerifyChipProps) {
  if (!result || result.verdict === 'DISABLED') return null;
  const c = CHIP[result.verdict];
  const showScore = result.verdict === 'NAME_MISMATCH' && result.matchScore != null;
  const showRecheck = result.verdict === 'UNKNOWN' && !!onRecheck;
  return (
    <div className="rd-verify-chip" style={{ display: 'grid', gap: 4 }}>
      <span className={c.cls} title="ผลตรวจกับกรมสรรพากร">
        <span aria-hidden>{c.icon}</span> {c.label}
        {showScore ? ` · คะแนนความตรง ${result.matchScore}` : ''}
      </span>
      {result.registeredName && (
        <div className="meta">
          ทะเบียน: {result.registeredName}
          {result.branchName ? ` · ${result.branchName}` : ''}
          {result.businessFirstDate && result.businessFirstDate !== '-'
            ? ` · จดทะเบียน ${result.businessFirstDate}`
            : ''}
        </div>
      )}
      {showRecheck && (
        <button type="button" className="btn sm ghost" disabled={recheckBusy} onClick={onRecheck}>
          {recheckBusy ? 'กำลังตรวจ…' : 'ตรวจสอบใหม่'}
        </button>
      )}
    </div>
  );
}
